/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { WebConfiguration as __Configuration } from '../web-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ConsumptionList } from '../models/consumption-list';
import { ConsumptionSearchOptions } from '../models/consumption-search-options';
import { InvoiceList } from '../models/invoice-list';
import { InvoiceSettings } from '../models/invoice-settings';

/**
 * All about the finance
 */
@Injectable({
  providedIn: 'root',
})
class FinanceService extends __BaseService {
  static readonly searchFinanceConsumptionsPath = '/finance/consumptions/search';
  static readonly exportFinanceConsumptionsPath = '/finance/consumptions/export';
  static readonly InvoiceListPath = '/finance/invoices';
  static readonly exportFinanceInvoicesPath = '/finance/invoices/export';
  static readonly InvoiceSettingsCreatePath = '/finance/settings';
  static readonly InvoiceSettingsPath = '/finance/settings';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Search financial consumptions
   *
   * Search financial consumptions
   * @param params The `FinanceService.SearchFinanceConsumptionsParams` containing the following parameters:
   *
   * - `date`: Month Date YYYY-MM
   *
   * - `search`: The consumption options object
   *
   * @return Success
   */
  searchFinanceConsumptionsResponse(params: FinanceService.SearchFinanceConsumptionsParams): __Observable<__StrictHttpResponse<ConsumptionList>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.date != null) __params = __params.set('date', params.date.toString());
    __body = params.search;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/finance/consumptions/search`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ConsumptionList>;
      })
    );
  }
  /**
   * Search financial consumptions
   *
   * Search financial consumptions
   * @param params The `FinanceService.SearchFinanceConsumptionsParams` containing the following parameters:
   *
   * - `date`: Month Date YYYY-MM
   *
   * - `search`: The consumption options object
   *
   * @return Success
   */
  searchFinanceConsumptions(params: FinanceService.SearchFinanceConsumptionsParams): __Observable<ConsumptionList> {
    return this.searchFinanceConsumptionsResponse(params).pipe(
      __map(_r => _r.body as ConsumptionList)
    );
  }

  /**
   * Export financial consumptions
   *
   * Export financial consumptions
   * @param params The `FinanceService.ExportFinanceConsumptionsParams` containing the following parameters:
   *
   * - `date`: Month Date YYYY-MM
   *
   * - `search`: The consumption options object
   *
   * @return Success
   */
  exportFinanceConsumptionsResponse(params: FinanceService.ExportFinanceConsumptionsParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.date != null) __params = __params.set('date', params.date.toString());
    __body = params.search;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/finance/consumptions/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * Export financial consumptions
   *
   * Export financial consumptions
   * @param params The `FinanceService.ExportFinanceConsumptionsParams` containing the following parameters:
   *
   * - `date`: Month Date YYYY-MM
   *
   * - `search`: The consumption options object
   *
   * @return Success
   */
  exportFinanceConsumptions(params: FinanceService.ExportFinanceConsumptionsParams): __Observable<Blob> {
    return this.exportFinanceConsumptionsResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * getInvoicesList
   *
   * Get Invoice List
   * @param date Month Date YYYY-MM
   * @return Success
   */
  InvoiceListResponse(date: string): __Observable<__StrictHttpResponse<InvoiceList>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (date != null) __params = __params.set('date', date.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/finance/invoices`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<InvoiceList>;
      })
    );
  }
  /**
   * getInvoicesList
   *
   * Get Invoice List
   * @param date Month Date YYYY-MM
   * @return Success
   */
  InvoiceList(date: string): __Observable<InvoiceList> {
    return this.InvoiceListResponse(date).pipe(
      __map(_r => _r.body as InvoiceList)
    );
  }

  /**
   * Export financial invoices
   *
   * Export financial invoices
   * @param date Month Date YYYY-MM
   * @return Success
   */
  exportFinanceInvoicesResponse(date: string): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (date != null) __params = __params.set('date', date.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/finance/invoices/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * Export financial invoices
   *
   * Export financial invoices
   * @param date Month Date YYYY-MM
   * @return Success
   */
  exportFinanceInvoices(date: string): __Observable<Blob> {
    return this.exportFinanceInvoicesResponse(date).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * Invoices settings
   *
   * Invoices settings Create
   * @param params The `FinanceService.InvoiceSettingsCreateParams` containing the following parameters:
   *
   * - `date`: Month Date YYYY-MM
   *
   * - `InvoiceSettings`: The billing setting object
   */
  InvoiceSettingsCreateResponse(params: FinanceService.InvoiceSettingsCreateParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.date != null) __params = __params.set('date', params.date.toString());
    __body = params.InvoiceSettings;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/finance/settings`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Invoices settings
   *
   * Invoices settings Create
   * @param params The `FinanceService.InvoiceSettingsCreateParams` containing the following parameters:
   *
   * - `date`: Month Date YYYY-MM
   *
   * - `InvoiceSettings`: The billing setting object
   */
  InvoiceSettingsCreate(params: FinanceService.InvoiceSettingsCreateParams): __Observable<null> {
    return this.InvoiceSettingsCreateResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Billing settings
   *
   * Billing settings
   * @param date Month Date YYYY-MM
   * @return Success
   */
  InvoiceSettingsResponse(date: string): __Observable<__StrictHttpResponse<InvoiceSettings>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (date != null) __params = __params.set('date', date.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/finance/settings`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<InvoiceSettings>;
      })
    );
  }
  /**
   * Billing settings
   *
   * Billing settings
   * @param date Month Date YYYY-MM
   * @return Success
   */
  InvoiceSettings(date: string): __Observable<InvoiceSettings> {
    return this.InvoiceSettingsResponse(date).pipe(
      __map(_r => _r.body as InvoiceSettings)
    );
  }
}

namespace FinanceService {

  /**
   * Parameters for searchFinanceConsumptions
   */
  export interface SearchFinanceConsumptionsParams {

    /**
     * Month Date YYYY-MM
     */
    date: string;

    /**
     * The consumption options object
     */
    search?: ConsumptionSearchOptions;
  }

  /**
   * Parameters for exportFinanceConsumptions
   */
  export interface ExportFinanceConsumptionsParams {

    /**
     * Month Date YYYY-MM
     */
    date: string;

    /**
     * The consumption options object
     */
    search?: ConsumptionSearchOptions;
  }

  /**
   * Parameters for InvoiceSettingsCreate
   */
  export interface InvoiceSettingsCreateParams {

    /**
     * Month Date YYYY-MM
     */
    date: string;

    /**
     * The billing setting object
     */
    InvoiceSettings: InvoiceSettings;
  }
}

export { FinanceService }
